export const MONTHLY_PLAN = 'MONTHLY_PLAN';

export const MONTHLY_PLAN_REBRAND = 'MONTHLY_PLAN_REBRAND';
export const YEARLY_PLAN_REBRAND = 'YEARLY_PLAN_REBRAND';
export const LIFETIME_PLAN_REBRAND = 'LIFETIME_PLAN_REBRAND';

export const REBRAND_BUNDLE_0_10_3M = 'REBRAND_BUNDLE_0_10_3M';
export const REBRAND_BUNDLE_0_10_6M = 'REBRAND_BUNDLE_0_10_6M';
export const REBRAND_BUNDLE_0_25_6M = 'REBRAND_BUNDLE_0_25_6M';
export const REBRAND_BUNDLE_0_25_12M = 'REBRAND_BUNDLE_0_25_12M';
export const REBRAND_BUNDLE_0_55_12M = 'REBRAND_BUNDLE_0_55_12M';

export const SIX_MONTH_PLAN = 'SIX_MONTH_PLAN';
export const ANNUALLY_PLAN = 'ANNUALLY_PLAN';

export const SUBSCRIPTION_CUSTOMER_CREATED = "customer_created";
export const SUBSCRIPTION_ACTIVE = "active";
export const SUBSCRIPTION_PAYMENT_FAILED = "payment_failed";
export const SUBSCRIPTION_USER_CANCEL = "user_cancel";
export const SUBSCRIPTION_AUTOMATIC_CANCEL = "user_automatic_cancel";
export const SUBSCRIPTION_CREATED_NEW = "created_new_subscription";

export interface Invoice {
  total: number,
  created: number,
  status: string,
  hosted_invoice_url: string
}

export interface UpcomingInvoiceItem {
  description: string,
  quantity: number,
  amount: string
}

export interface UpcomingInvoice {
  currency: string,
  periodStart: number,
  periodEnd: number,
  subtotal: string,
  total: string,
  amount_due: string,
  //tax: string,
  total_discount_amounts?: string,
  discountName?: string,
  invoiceItems: UpcomingInvoiceItem[]
}
